import { CodeConfigurationField } from '@dtx-company/inter-app/src/types/flowcode'
import { LoggedOutGeneratorSection } from '@dtx-company/app/shared/code/src/components/LoggedOutCodeGeneratorV2/LoggedOutCodeGenerator.types'
import { fireAnalyticsEvent } from '@dtx-company/inter-app/src/event-tracking/helpers/fireAnalyticsEvent'
import {
  selectError,
  selectScanDestinationType
} from '@dtx-company/app/shared/code/src/machines/locg/locgSelectors'
import { useGlobalServices } from '@dtx-company/app/shared/common/src/hooks/useGlobalServices'
import { useSelector } from '@xstate/react'
import { useState } from 'react'

export const useAccordionLOCG = (): {
  expanded: LoggedOutGeneratorSection | null
  onSubmitError: () => void
  onAccordionChange: (expanded: boolean, section: LoggedOutGeneratorSection) => void
  selectedScanDestinationType: ReturnType<typeof selectScanDestinationType>
} => {
  const [expanded, setExpanded] = useState<LoggedOutGeneratorSection | null>(
    LoggedOutGeneratorSection.ScanDestination
  )
  const { locgService } = useGlobalServices()

  const selectedScanDestinationType = useSelector(locgService, selectScanDestinationType)

  const scanDestinationError = useSelector(
    locgService,
    selectError
  )(CodeConfigurationField.SCAN_DESTINATION)

  const scanDestinationFileError = useSelector(
    locgService,
    selectError
  )(CodeConfigurationField.FILE)

  const onAccordionChange = (expanded: boolean, section: LoggedOutGeneratorSection): void => {
    fireAnalyticsEvent('LoggedOutGenerator_Accordion_Change', { section, expanded })
    setExpanded(expanded ? section : null)
  }

  const onSubmitError = (): void => {
    if (scanDestinationError || scanDestinationFileError) {
      onAccordionChange(true, LoggedOutGeneratorSection.ScanDestination)
    }
  }

  return {
    expanded,
    onSubmitError,
    onAccordionChange,
    selectedScanDestinationType
  }
}
